/**
 * 🎁 Referral Program Types
 * Shared types for the secure server-side referral system
 */
// ============================================================================
// Enums
// ============================================================================
export var ReferralRewardStatus;
(function (ReferralRewardStatus) {
    ReferralRewardStatus["PENDING"] = "PENDING";
    ReferralRewardStatus["CONFIRMED"] = "CONFIRMED";
    ReferralRewardStatus["CANCELLED"] = "CANCELLED";
    ReferralRewardStatus["EXPIRED"] = "EXPIRED";
})(ReferralRewardStatus || (ReferralRewardStatus = {}));
export var ReferralEventType;
(function (ReferralEventType) {
    ReferralEventType["CODE_GENERATED"] = "CODE_GENERATED";
    ReferralEventType["CODE_VALIDATED"] = "CODE_VALIDATED";
    ReferralEventType["CODE_APPLIED"] = "CODE_APPLIED";
    ReferralEventType["REWARD_EARNED"] = "REWARD_EARNED";
    ReferralEventType["REWARD_USED"] = "REWARD_USED";
    ReferralEventType["REWARD_EXPIRED"] = "REWARD_EXPIRED";
    ReferralEventType["FRAUD_DETECTED"] = "FRAUD_DETECTED";
})(ReferralEventType || (ReferralEventType = {}));
